'use client';

import { useTranslations } from '@/hooks/use-translations';
import {
  Card,
  CardBody,
  Tab,
  Tabs
} from '@heroui/react';
import { IconArrowRight } from '@tabler/icons-react';
import Image from 'next/image';
import Link from 'next/link';

export const Space = () => {
  const t = useTranslations();

  if (!t) return null;

  const tabs = [
    {
      id: 'comfort',
      label: t.space.comfort.title,
      content: t.space.comfort.description,
      image: '/images/lab/cafe.webp',
    },
    {
      id: 'flexibility',
      label: t.space.flexibility.title,
      content: t.space.flexibility.description,
      image: '/images/lab/middle-3.webp',
    },
    {
      id: 'community',
      label: t.space.community.title,
      content: t.space.community.description,
      image: '/images/lab/desk.webp',
    },
    // {
    //   id: 'location',
    //   label: t.space.location.title,
    //   content: t.space.location.description,
    //   image: '/assets/map-pin.png',
    //   isClickable: true,
    //   link: 'https://maps.app.goo.gl/gUEqSqWYJhMMKBTs5',
    // },
  ];

  return (
    <section id="space" className="min-h-[500px]">
      <div className="mx-auto desktop:px-4 flex flex-col items-center">
        <div className="text-center">
          <p className="font-bold mb-4 text-4xl desktop:text-5xl">
            {t.space.title}
          </p>
          <p className="text-foreground/75 text-lg desktop:text-xl max-w-3xl mx-auto">
            {t.space.subtitle}
          </p>
          <div className="flex items-center justify-center mt-2">
            <Link
              className="flex mt-2 items-center gap-1 text-primary hover:text-primary-600 underline"
              target="_blank"
              href="https://maps.app.goo.gl/gUEqSqWYJhMMKBTs5">
              Visualizza su Google Maps
              <IconArrowRight size={14}
              />
            </Link>
          </div>
        </div>

        <div className="flex flex-col items-center mt-8 w-full">
          <Tabs
            aria-label="Solution Tabs"
            className="w-full [&_>_div]:overflow-x-auto [&_>_div]:scrollbar-hide"
            classNames={{
              tabList: 'mx-auto',
              panel: 'w-full px-0 mx-0',
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={tab.id}
                title={tab.label}
              >
                <Card className="w-full mt-4">
                  <CardBody className="p-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center w-full">
                      <div className="order-2 md:order-1 flex items-center justify-center w-full">
                        <p className="text-foreground/80 text-lg leading-relaxed text-center md:text-left">
                          {tab.content}
                        </p>
                      </div>
                      <div className="order-1 md:order-2 w-full flex justify-center items-center">
                        <div className="w-full flex justify-center">
                          <Image
                            src={tab.image}
                            alt={tab.label}
                            width={384}
                            height={256}
                            className="w-full max-w-sm h-64 object-cover rounded-xl shadow-lg"
                            loading={index === 0 ? "eager" : "lazy"}
                            priority={index === 0}
                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 384px"
                          />
                          {/* )} */}
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Tab>
            ))}
          </Tabs>
        </div>
      </div>
    </section>
  );
};
